import { inject, Pipe, PipeTransform } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { UserService } from '../services/user.service';

@Pipe({
  name: 'azureIdStatus',
  pure: true
})
export class AzureIdStatusPipe implements PipeTransform {
  private userService = inject(UserService);

  /**
   * @description Checks if an Azure ID can be found and returns appropriate indicator
   * @param input Azure ID of the user to check
   * @returns {Observable<string>} Empty string if found, left arrow (←) if not found
   */
  transform(input: string | null): Observable<string> {
    if (!input) return of('');

    // Try to get the user regardless of Azure ID format
    return this.userService.getUser(input).pipe(
      map((user) => {
        if (user && user.displayName && !user.displayName.includes('Unknown User')) {
          return ''; // User found, return empty string
        } else {
          return '(terminated)'; // User not found, return left arrow
        }
      })
    );
  }
}
